export default "__VITE_ASSET__a3e19fda__"